import Main from './_main';
import ScrollAnimation from './_scrollAnimation';
import Home from './_home';

new Main();
new ScrollAnimation();
new Home();
